<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title>Billing PDF for {{param.eign_code}} {{param.eign_naam}}</v-card-title>

      <v-row no-gutters class="mx-4">
         <v-col cols="5" class="mx-2">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.van_dat" 
              label="Arrival date from"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

          <v-col cols="5" class="mx-2">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.tm_dat" 
              label="Arrival date until"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>

      </v-row>  
     
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="ovrz">Create Billing PDF</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>


  </v-card>
  <showProgress ref="showProgress"></showProgress>  
</v-dialog>
</template>

<script>
import showProgress from "@/components/showProgress.vue"; 
export default {
  components: {
     showProgress
  },
  data() { 
    return {
      dialog: false,
      eign_encrid: null,
      dat1menu: false,
      dat2menu: false,
      hulpDate: '',
      param: {},
      submitted: false
    }
  },
  methods: {
    open(eign_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/ovrz/getBilling1Param.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getBilling1Param"
          },
          getBilling1Param: {
            eign_encrid: eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.param = res.data.getBilling1Param;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

     ovrz() {
      this.submitted = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/eign/ovrz/pdfBilling1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "pdfBilling1"
          },
          pdfBilling1: {
            eign_encrid: this.param.eign_encrid,
            van_dat: this.param.van_dat,
            tm_dat: this.param.tm_dat
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.pdfBilling1;
            this.$refs.showProgress.close();
            this.submitted = false;
            this.dialog = false;
            window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

  }
}
</script>




